module.exports = __webpack_public_path__ + "img/10.5ef8b278.png";